import { LEAVE_POLICY_COPY } from '../content/countryPolicyContent';

/** One-line definition for when to use each leave type. Key = LeaveType.Code. */
export const LEAVE_TYPE_DEFINITIONS: Record<string, string> = {
  Annual: 'Planned time off for rest and recreation (e.g. holidays). Counts toward your annual leave entitlement.',
  Family: LEAVE_POLICY_COPY.familyDefinition,
  Sick: LEAVE_POLICY_COPY.sickDefinition,
  Study: 'For Microsoft certification exams. Typical use: one day prep and one day per exam. Cap: 10 days per year. Proof of exam registration is required before submit. Offered for first attempt only. Over cap you must choose annual leave. Requires at least one year of service.',
  TOIL: 'Time off in lieu for extra hours worked. Must be agreed with your manager beforehand—it\'s discretionary, not automatic. Availability may vary by role. Does not count toward annual leave. Ask your manager if unsure.',
  Parental: LEAVE_POLICY_COPY.parentalDefinition,
};

/** Display name for sidebar list (code → label). Matches API LeaveType.Name where applicable. */
export const LEAVE_TYPE_DISPLAY_NAMES: Record<string, string> = {
  Annual: 'Annual Leave',
  Family: 'Family Responsibility Leave',
  Sick: 'Sick Leave',
  Study: 'Microsoft Exam Leave',
  TOIL: 'Time off in Lieu',
  Parental: 'Parental Leave',
};
